import { useMemo } from "react";
import { object, string } from "yup";


export type Rattachement = {
  sourceUid: string;
  targetEmailAddress: string;
  targetPassword: string;
};

const useValidationSchemaRattachement = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";
    const invalidEmailMessage = "form.error.emailInvalid";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<Rattachement>().shape({
      sourceUid: string().required(requiredMessage),
      targetEmailAddress: string().email(invalidEmailMessage).required(requiredMessage),
      targetPassword: string().required(requiredMessage),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaRattachement;
